import { useCallback, useEffect, RefObject } from 'react';
import { MODAL_ID } from 'src/constants';
import { CommonUtils } from 'src/utils';

export function useOutsideClick(
    inside:
        | RefObject<null | HTMLElement>
        | Array<RefObject<null | HTMLDivElement>>,
    onOutsideClick: (isInside: boolean) => void,
    active: boolean = true
) {
    const onMouseUp = useCallback(
        (e: MouseEvent) => {
            let isInside = Array.isArray(inside)
                ? inside.some(
                    (element) =>
                        !!element &&
                        !!element.current &&
                        CommonUtils.isElement(element.current) &&
                        element.current.contains(e.target as HTMLDocument)
                )
                : !!inside &&
                !!inside.current &&
                CommonUtils.isElement(inside.current) &&
                inside.current.contains(e.target as HTMLDocument);

            if (!isInside) {
                //external inside
                const insides: HTMLDivElement[] = [];
                const modal: HTMLDivElement | null = document.getElementById(
                    MODAL_ID
                ) as HTMLDivElement;
                if (modal) {
                    insides.push(modal);
                }
                isInside = insides.some(
                    (element) =>
                        !!element &&
                        CommonUtils.isElement(element) &&
                        element.contains(e.target as HTMLDocument)
                );
            }

            onOutsideClick(isInside);
        },
        [onOutsideClick, inside]
    );

    useEffect(() => {
        if (active) {
            document.addEventListener('mouseup', onMouseUp);
            return () => {
                document.removeEventListener('mouseup', onMouseUp);
            };
        }
        return;
    }, [active, onMouseUp]);
}

export default useOutsideClick;
